<template>
    <div id="app">
        <layout-header />

        <router-view
            @enable-footer="footerEnabled = true"
            @disable-footer="footerEnabled = false" />

        <layout-footer v-if="footerEnabled" />

        <div class="pageloader" :class="{'is-active': pageIsLoading}">
            <span class="title">Indlæser...</span>
        </div>

        <cookie-notice />
    </div>
</template>

<style lang="scss">
    @import '/global/styles/main';

    #app.modal--open {
        overflow: hidden;
        position: fixed;
    }

    .pageloader {
        background-color: $primary;

        .title {
            font-size: 20px;
        }
    }
</style>

<script>
    import LayoutHeader from '@/global/layout/Header';
    import LayoutFooter from '@/global/layout/Footer';
    import CookieNotice from '@/global/components/CookieNotice';

    export default {
        data() {
            return {
                footerEnabled: true,
                pageIsLoading: true,
            };
        },

        metaInfo: {
            title: 'Dygtige studerende: Spar tid og penge i din virksomhed',
            titleTemplate: '%s | Taskflex',
            meta: [
                {
                    vmid: 'description',
                    name: 'description',
                    content: 'Få dygtige studerende til at løse opgaver som bogføring, grafisk design, opsætning af hjemmeside osv… til en brøkdel af den normale pris!',
                },
                {
                    property: 'og:title',
                    content: 'Dygtige studerende: Spar tid og penge i din virksomhed | Taskflex',
                },
                {
                    property: 'og:type',
                    content: 'article',
                },
                {
                    property: 'og:url',
                    content: 'https://www.taskflex.dk', // TODO fix urls somehow
                },
                {
                    property: 'og:description',
                    content: 'Få dygtige studerende til at løse opgaver som bogføring, grafisk design, opsætning af hjemmeside osv… til en brøkdel af den normale pris!',
                },
                {
                    property: 'og:image',
                    content: 'https://www.taskflex.dk/static/images/og/2.png', // never remove this file
                },
                {
                    property: 'og:image',
                    content: 'https://www.taskflex.dk/static/images/og/5.png', // never remove this file
                },
                {
                    property: 'og:image',
                    content: 'https://www.taskflex.dk//static/images/og/6.png', // never remove this file
                },
            ],
        },

        mounted() {
            this.$store.dispatch('auth/autoLogin')
                .then(() => {
                    const { query } = this.$route;

                    if (query.redirect) {
                        this.$router.replace(query.redirect);
                    }

                    this.pageIsLoading = false;
                })
                .catch(() => {
                    this.pageIsLoading = false;
                });
        },

        components: {
            LayoutHeader,
            LayoutFooter,
            CookieNotice,
        },
    };
</script>



// WEBPACK FOOTER //
// src/App.vue